import { Computer } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const DesktopBadge = () => {
  const { isMobile } = useResponsiveDesign()

  if (!isMobile) return null

  return <Computer size={16} color="var(--dark-25)" />
}
